import React from "react";
import About from "../Candidate/About";
import Section from "../Candidate/Section";
import Counter from "../AboutUs/Counter";
import Features from "../Candidate/Features";
import Cta from "../Candidate/Cta";
import HowHiringProcessWorks from "../Candidate/HowHiringProcessWorks";
import CompanyTestimonal from "../Candidate/CompanyTestimonal";

const Candidate = () => {
    document.title = "Candidate - Matrix Executive Search Group";
    return (
        <React.Fragment>
            <Section />
            <HowHiringProcessWorks />
            <About />
            <Counter />
            <Features />
            <CompanyTestimonal />
            <Cta />
        </React.Fragment>
    );
};

export default Candidate;
